import {WlBanner} from "./banner.component";

export * from './banner.component';
export default WlBanner;

customElements.define('wl-display', WlBanner);